import { render, staticRenderFns } from "./BankReportDetails.vue?vue&type=template&id=af7b88d8&"
import script from "./BankReportDetails.vue?vue&type=script&lang=js&"
export * from "./BankReportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports